var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0307 15H6.84019C6.33706 15 5.85453 14.7998 5.49876 14.4435C5.14299 14.0872 4.94312 13.6039 4.94312 13.1V4.9C4.94312 3.85066 5.79247 3 6.84019 3H13.0307C14.0784 3 14.9277 3.85066 14.9277 4.9V13.1C14.9277 14.1493 14.0784 15 13.0307 15ZM6.84019 4.8C6.78505 4.8 6.74035 4.84477 6.74035 4.9V13.1C6.74035 13.1552 6.78505 13.2 6.84019 13.2H13.0307C13.0858 13.2 13.1305 13.1552 13.1305 13.1V4.9C13.1305 4.84477 13.0858 4.8 13.0307 4.8H6.84019Z",
    fill: "#2A6EBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84625 11C3.34254 11 3.74486 10.5971 3.74486 10.1V1.9C3.74486 1.84477 3.78957 1.8 3.84471 1.8H10.0352C10.5315 1.8 10.9338 1.39706 10.9338 0.9C10.9338 0.402944 10.5315 0 10.0352 0H3.84471C2.79698 0 1.94763 0.850659 1.94763 1.9V10.1C1.94763 10.3387 2.04231 10.5676 2.21083 10.7364C2.37935 10.9052 2.60792 11 2.84625 11Z",
    fill: "#2A6EBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.bd50826eb2f12603a5f2efcd5c736faf.svg";
export { ForwardRef as ReactComponent };